<script setup lang="ts">
import { router } from "@inertiajs/vue3"
import type { DropdownMenuItem } from "@nuxt/ui"
import { computed } from "vue"

import { ICON } from "@/lib/icons"
import { editItemPath, printPath } from "@/routes"

const props = defineProps<{
  name: string
  typeName?: string | null
  itemId: string
  isContainer?: boolean
  hasActiveLoan?: boolean
  archived?: boolean
  system?: boolean
}>()

const emit = defineEmits<{
  recordLoan: []
  editContainer: []
  duplicateItem: []
  deleteItem: []
  archiveItem: []
  restoreItem: []
}>()

const menuItems = computed<DropdownMenuItem[][]>(() => [
  [
    ...(props.isContainer
      ? [{ label: "Edit Container", icon: ICON.edit, onSelect: () => emit("editContainer") }]
      : []),
    ...(!props.archived && !props.hasActiveLoan
      ? [{ label: "Record a Loan", icon: ICON.loan, onSelect: () => emit("recordLoan") }]
      : []),
    { label: "Re-analyze with AI", icon: ICON.ai, disabled: true },
    { label: "Duplicate", icon: ICON.duplicate, onSelect: () => emit("duplicateItem") },
    {
      label: "Print Label",
      icon: ICON.print,
      onSelect: () => router.visit(printPath({ item_id: props.itemId })),
    },
    ...(!props.isContainer
      ? [{ label: "Make container", icon: ICON.container, disabled: true }]
      : []),
    { label: "Export", icon: ICON.export, disabled: true },
  ],
  [
    ...(props.archived
      ? [{ label: "Restore", icon: ICON.restore, onSelect: () => emit("restoreItem") }]
      : !props.system
        ? [{ label: "Archive", icon: ICON.archive, onSelect: () => emit("archiveItem") }]
        : []),
    {
      label: "Delete",
      icon: ICON.delete,
      color: "error" as const,
      onSelect: () => emit("deleteItem"),
    },
  ],
])

const editLabel = computed(() => (props.isContainer ? "Edit Item" : "Edit"))
</script>

<template>
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0 flex-1">
      <h1 class="text-highlighted text-xl font-semibold">{{ name }}</h1>
      <p v-if="typeName" class="text-muted mt-1 text-xs">{{ typeName }}</p>
    </div>
    <div class="flex shrink-0 items-center gap-2">
      <UButton
        v-if="!archived"
        :label="editLabel"
        :icon="ICON.edit"
        color="neutral"
        variant="outline"
        size="sm"
        @click="router.visit(editItemPath({ id: itemId }))"
      />
      <UDropdownMenu :items="menuItems">
        <UButton
          :icon="ICON.more"
          aria-label="Item actions"
          color="neutral"
          variant="ghost"
          square
        />
      </UDropdownMenu>
    </div>
  </div>
</template>
